module.exports = __webpack_public_path__ + "img/gobiernoOaxaca.abc794da.png";